import { useQuery } from '@tanstack/react-query';
import { getTeamSurveyOverview } from '../../api/workEnvironmentQueries';

export const TeamSurveyOverviewQueryKey = 'TEAM_SURVEY_OVERVIEW';

export const useTeamSurveyOverviewQuery = (teamId: number, language: string) =>
  useQuery({
    queryKey: [TeamSurveyOverviewQueryKey, teamId, language],
    queryFn: () => getTeamSurveyOverview(teamId, language),
    enabled: !!teamId,
  });
